module.exports = __webpack_public_path__ + "img/hu.2d1fd1c8.svg";